import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import ApiRequestService from './ApiRequestService';
import { NotificationManager } from 'react-notifications';

const SFSemesterDropdown = ({ selectedSemester, onChange }) => {
    const [loading, setLoading] = useState(false);
    const [semesters, setSemesters] = useState([]);
    // const [selectedSemester, setSelectedSemester] = useState(null)

    useEffect(() => {
        getAllSemesters();
    }, [])

    const getAllSemesters = () => {
        setLoading(true)
        ApiRequestService({
            method: 'post',
            url: '/getAllSemesters'
        }).then(res => {
            if (res && res.data && res.data.data) {
                setSemesters(res.data.data);
                let currentSemester = res.data.data.find(sem => sem.isCurrent);
                if (currentSemester) {
                    onChange({
                        id: currentSemester.id,
                        label: currentSemester.name,
                        data: currentSemester,
                    })
                }
                return;
            }
            if (res && res.data && res.data.message) {
                NotificationManager.error("Could not fetch all semesters", "Error", 3000);
                return;
            }
            NotificationManager.error("Server error", "Error", 3000);
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <Autocomplete
            disabled={loading}
            disablePortal
            disableClearable
            // style={{ width: "100%" }}
            options={semesters ? semesters.map(semester => {
                return {
                    id: semester.id,
                    label: semester.name,
                    data: semester,
                }
            }) : []}
            getOptionLabel={(option) => {
                let text = option.label;
                if (option.data && option.data.isCurrent) {
                    text += " (Current)"
                }
                return text;
            }}
            sx={{ maxWidth: 300 }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={selectedSemester}
            onChange={(_, value) => onChange(value)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Semesters"
                    InputProps={{
                        ...params.InputProps,
                        sx: {
                            background: "#fff",
                            borderRadius: "8px",
                        },
                    }}
                />
            )}
        />
    );
}

export default SFSemesterDropdown;
